<div class="append-container">
  <kendo-stacklayout class="grid-layout-container" [gap]="2" [align]="{ horizontal: hAlign}">
    <div *ngFor="let m of modulos">
      <div class="locker-wrapper">
        <kendo-gridlayout class="" [rows]="m.linhas" [cols]="m.colunas" [gap]="2">
          <kendo-gridlayout-item *ngFor="let c of m.compartimentos" [col]="c.coluna" [row]="c.linha"
            [rowSpan]="c.linhaSpan" [ngClass]="alertaCor(c)" class="box rect">

            <span>
              <small class="boxmicro" kendoTooltip title="{{getTranslatedText(c)}}">
                <button kendoButton [disabled]="true" class=disabled-button [style]="estadoBtn(c)">
                  {{c.nome}}
                </button>
                <small class="getText">
                  {{ getText(c)}}
                </small>
              </small>
            </span>
          </kendo-gridlayout-item>
        </kendo-gridlayout>
      </div>
    </div>
  </kendo-stacklayout>

  <!-- legenda -->
  <br>

  <div class="legenda">
    <div class="legenda-item">
      <span class="box greybox">{{customMsgService.translate('inibido')}}</span>
      <span class="space"></span>
      <span class="box yellowbox">{{customMsgService.translate('stockBaixo')}}</span>
      <span class="space"></span>
      <span class="box redbox">{{customMsgService.translate('anomalia')}}</span>

    </div>
